module.exports = __webpack_public_path__ + "static/img/banner-center.903c93c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-center.png
// module id = SB/P
// module chunks = 3